import React from "react";
import { size } from "lodash";
import { IllustrationProps } from ".";

export default ({
  colors: { base, scheme },
  options: { scatterPlot },
}: IllustrationProps) => {
  const numberOfColors = size(scheme);
  const _scheme = numberOfColors === 0 ? [base] : scheme;
  const isMonochrome = size(_scheme) === 1;
  return (
    <svg width="100%" height="100%" viewBox="0 0 440 120">
      {scatterPlot
        ? getScatterPlotIllustration(isMonochrome, numberOfColors, _scheme)
        : getBubbleChartIllustration(isMonochrome, numberOfColors, _scheme)}
    </svg>
  );
};

function getScatterPlotIllustration(
  isMonochrome: boolean,
  numberOfColors: number,
  _scheme: string[]
) {
  return (
    <>
      {(isMonochrome || numberOfColors >= 3) && (
        <circle cx="370" cy="42" r="12" fill={_scheme[isMonochrome ? 0 : 2]} />
      )}
      <circle cx="62" cy="48" r="12" fill={_scheme[isMonochrome ? 0 : 1]} />
      {(isMonochrome || numberOfColors >= 5) && (
        <circle cx="362" cy="54" r="12" fill={_scheme[isMonochrome ? 0 : 4]} />
      )}
      {(isMonochrome || numberOfColors >= 4) && (
        <circle cx="155" cy="81" r="12" fill={_scheme[isMonochrome ? 0 : 3]} />
      )}
      <circle cx="253" cy="42" r="12" fill={_scheme[0]} />
    </>
  );
}

function getBubbleChartIllustration(
  isMonochrome: boolean,
  numberOfColors: number,
  _scheme: string[]
) {
  return (
    <>
      {/* Left */}
      {(isMonochrome || numberOfColors >= 3) && (
        <circle fill={_scheme[isMonochrome ? 0 : 1]} cx={62} cy={50} r={35} />
      )}
      {/* Left middle */}
      <circle
        fill={_scheme[3] || _scheme[1] || _scheme[0]}
        cx={80}
        cy={82}
        r={17}
      />
      {(isMonochrome || numberOfColors >= 5) && (
        <circle fill={_scheme[4] || _scheme[0]} cx={390} cy={55} r={35} />
      )}
      {/* Right middle */}
      {(isMonochrome || numberOfColors >= 3) && (
        <circle fill={_scheme[2] || _scheme[0]} cx={276} cy={75} r={10} />
      )}
      {/* Right */}
      <circle fill={_scheme[0]} cx={163} cy={54} r={27} />
    </>
  );
}
